<template>
    <v-layout justify-center column>
      <v-flex xs5 lg5>
          <form v-if="!response"
            name="tab-tracker-form"
            autocomplete="off">
            <v-text-field
              name="firstName"
              :label="$t('account.firstName')"
              required
              v-model='firstName'>
            </v-text-field>
            <v-text-field
              name="lastName"
              :label="$t('account.lastName')"
              required
              v-model='lastName'>
            </v-text-field>
            <v-text-field
              name="email"
              :label="$t('account.email')"
              autocomplete="email"
              v-model="email"
              required
            ></v-text-field>
            <v-text-field
              name="company"
              :label="$t('companyGenerics.companyUniqueId')"
              required
              v-model='companyId'>
            </v-text-field>
            <v-text-field
              name="phoneNumber"
              autocomplete="tel"
              :label="$t('account.phoneNumber')"
              required
              v-model='phoneNumber'>
            </v-text-field>
            <v-text-field
              name="password"
              :label="$t('account.password')"
              :type="showPasswordFirst ? 'text' : 'password'"
              v-model="password"
              autocomplete="new-password"
              required
            >
              <template v-slot:append>        
                <v-icon size="18" @click="() => (showPasswordFirst = !showPasswordFirst)"> {{showPasswordFirst ? 'fa-eye' : 'fa-eye-slash'}} </v-icon> 
              </template>
            </v-text-field>
            <v-text-field
              name="password-confirm"
              :label="$t('account.confirmPassword')"
              :type="showPasswordSecond ? 'text' : 'password'"
              v-model="conf_password"
              autocomplete="new-password"
              :rules="[confirm_password]"
              required
            >
              <template v-slot:append>        
                <v-icon size="18" @click="() => (showPasswordSecond = !showPasswordSecond)"> {{showPasswordSecond ? 'fa-eye' : 'fa-eye-slash'}} </v-icon> 
              </template>
            </v-text-field>
          </form>
          <br>
          <div class="danger-alert" v-html="error" />
          <div class="danger-info" v-html="response.msg" />
          <br>
          <v-btn
            v-if="!response"
            dark
            block
            large
            class="secondary login-button"
            @click="register">
            {{$t('account.register')}}
          </v-btn>
          <v-btn
            flat
            @click="$emit('login')">
            < {{$t('account.logIn')}}
          </v-btn>
      </v-flex>
    </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import i18n from '@/plugins/i18n'
export default {
  data () {
    return {
      email: '',
      password: '',
      conf_password: '',
      companyId: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      error: null,
      valid: false,
      response: '',
      showPasswordFirst: false,
      showPasswordSecond: false,
      confirm_password: (value) => this.password === value || i18n.t('mainErrors.passwordsNotSame')
    }
  },
  methods: {
    async register () {
      try {
        this.error = ''
        const responseApi = await AuthenticationService.register({
          username: this.email,
          password: this.password,
          unique_id: this.companyId,
          first_name: this.firstName,
          last_name: this.lastName,
          phone_number: this.phoneNumber
        })

        if(!responseApi || ![200, 201].includes(responseApi.status)) {
          throw responseApi
        }

        this.response = responseApi.data;
        this.response.msg = 'Success!';
      } catch (error) {
        console.log(error)
        if(typeof error.data === 'string')
          this.error = error.data
        else
          this.error = 'An error occurred.'
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue